import React from 'react';
import { Box } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import CategoriesSection from '../components/CategoriesSection';
import ParentsAppealSection from '../components/ParentsAppealSection';
import ConsultationTypesSection from '../components/ConsultationTypesSection';
import ReviewsSection from '../components/ReviewsSection';
import CenterInfoSection from '../components/CenterInfoSection';
import NationalProjectSection from '../components/NationalProjectSection';
import SpecialistsSection from '../components/SpecialistsSection';
import EventsSection from '../components/EventsSection';
import ContactForm from '../components/ContactForm';

function Home() {
  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      {/* Декоративные 3D кубики */}
      <Box
        component="img"
        src="/img/brighter_tinted_cube4-ts1740842029.png"
        alt=""
        sx={{
          position: 'absolute',
          top: '10%',
          left: '-50px',
          width: { xs: 120, md: 200 },
          height: { xs: 120, md: 200 },
          opacity: 0.3,
          transform: 'rotate(15deg)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />
      <Box
        component="img"
        src="/img/brighter_tinted_cube4-ts1740842029.png"
        alt=""
        sx={{
          position: 'absolute',
          top: '30%',
          right: '-30px',
          width: { xs: 100, md: 180 },
          height: { xs: 100, md: 180 },
          opacity: 0.25,
          transform: 'rotate(-20deg)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />
      <Box
        component="img"
        src="/img/brighter_tinted_cube4-ts1740842029.png"
        alt=""
        sx={{
          position: 'absolute',
          top: '60%',
          left: '5%',
          width: { xs: 80, md: 150 },
          height: { xs: 80, md: 150 },
          opacity: 0.2,
          transform: 'rotate(45deg)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />
      <Box
        component="img"
        src="/img/brighter_tinted_cube4-ts1740842029.png"
        alt=""
        sx={{
          position: 'absolute',
          bottom: '15%',
          right: '10%',
          width: { xs: 90, md: 160 },
          height: { xs: 90, md: 160 },
          opacity: 0.3,
          transform: 'rotate(-30deg)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />
      
      {/* Основной контент */}
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Header />
        <HeroSection />
        <NationalProjectSection />
        <CategoriesSection />
        <ParentsAppealSection />
        <ConsultationTypesSection />
        <ReviewsSection />
        <CenterInfoSection />
        <Footer />
      </Box>
    </Box>
  );
}

export default Home;
